import { Pipe, PipeTransform } from '@angular/core';
import { TMarkedDefect } from '@monorepo/types';
import * as _ from 'lodash';

export type TSilhouetteMarkers = {
  color: string;
  coordinates: [x: number, y: number];
}[];

@Pipe({
  name: 'frontMarkers',
})
export class FrontSilhouetteDefectMarkerPipe implements PipeTransform {
  transform(markedDefects: TMarkedDefect[]): TSilhouetteMarkers {
    const filterMarkedDefects = markedDefects.filter((v) => v.silhuetteType === 'FRONT');
    return _.flatten(
      filterMarkedDefects.map((v) =>
        v.coordinate.map((c) => ({
          color: v.color,
          coordinates: c,
        })),
      ),
    );
  }
}
